import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectService } from '@catcore/services';
import { AircraftRegistrationService } from '@catmodules/models/userdata-generation/services/aircraft-registration.service';
import { UserdataConfigService } from '@catmodules/models/userdata-generation/services/userdata-config.service';
import { UserdataFileService } from '@catmodules/models/userdata-generation/services/userdata-file.service';
import { UserdataGenerationService } from '@catmodules/models/userdata-generation/services/userdata-generation.service';
import { UIBaseModule } from '@catui/ui-base.module';
import { UIFormModule } from '@catuiform/ui-form.module';
import { ButtonModule, CheckboxModule, DataTableModule, MessageModule, MessagesModule, TreeModule } from 'primeng/primeng';

import { FolderTreeViewComponent } from './components/folder-treeview/folder-treeview.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import {
  UserdataGenerationBriefingsComponent,
} from './components/userdata-generation-briefings/userdata-generation-briefings.component';
import {UserdataFileVersionService} from "@catmodels/userdata-generation/services/userdata-file-version.service";

const publicComponents = [
  UserdataGenerationBriefingsComponent,
  FolderTreeViewComponent,
  ImageUploadComponent,
];

const declarations = [
  ...publicComponents,
];

const imports = [
  CommonModule,
  FormsModule,
  UIBaseModule,
  UIFormModule,
  ReactiveFormsModule,
  DataTableModule,
  MessagesModule,
  MessageModule,
  CheckboxModule,
  ButtonModule,
  TreeModule,
  HttpClientModule,
];

const exportings = [...publicComponents];

const providers = [
  UserdataGenerationService,
  AircraftRegistrationService,
  UserdataFileService,
  UserdataFileVersionService,
  UserdataConfigService,
  ProjectService,
];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class UserdataGenerationModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/userdata-generation/userdata-generation.module.ts